module.exports = __webpack_public_path__ + "static/media/RedCard.ca641f35.svg";